import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { APP_URL } from 'types';
import { Loading } from 'carbon-components-react';
import { useSaga } from 'use-reducer-saga';
import reducer, { initialState } from './localStore/reducer';
import sagas from './localStore/sagas';
import { logoutStart } from './localStore/actions';
import { useComponentMount } from 'utilities/hooks.util';
import { endSession } from 'redux/session/actions';

export const Logout: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [localStore, localDispatch] = useSaga(reducer, initialState, sagas);
  const { status: logoutStatus } = localStore;

  useEffect(() => {
    if (logoutStatus === 'failed-log-out' || logoutStatus === 'loged-out') {
      dispatch(endSession());
      history.push(APP_URL.AUTH);
    }
  }, [logoutStatus, history, dispatch]);

  useComponentMount(() => {
    localDispatch(logoutStart());
  });

  return <Loading withOverlay={true} />;
};

Logout.displayName = 'Logout';

export default React.memo(Logout);
